import React  from "react";
import { useParams } from 'react-router-dom';
import { connect } from "react-redux";
import PayrollForm from "./components/PayrollForm";
import PayrollPayrunTable from "./components/PayrollPayrunTable";
import DownloadButton from "components/button/download";
import PayrollProcessButton from "./components/PayrollProcessButton";
import { PAY_STAT_DRAFT,
	PAY_STAT_INPROGRESS,
	PAY_STAT_VALIDATED, 
	PAY_STAT_APPROVED,
	PAY_STAT_RELEASED,  
	PAYROLL_TYPE_REG,
	PAYROLL_TYPE_OFFCYCLE,
} from "variables/constants";

const ViewPayroll = ({recordData, ...props}) => {
	const { payrollId } = useParams();
	
	const { searchFilters } = props;

	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<PayrollForm recordId={payrollId} mode="view"/>
			 	<PayrollPayrunTable payrollId={payrollId}/>
			 	
			 	{recordData && (
			 	<div className="flex flex-row-reverse text-right">
			 	
			 		{recordData?.pay_status_id < PAY_STAT_VALIDATED && (<>
						{recordData?.pay_type_id === PAYROLL_TYPE_REG && <>
							<PayrollProcessButton 
								payrollId={payrollId}
								process="dtr validated"
								confirmationMessage="Once the DTR is validated, it cannot be resynced or updated anymore."
							>
								DTR Validated
							</PayrollProcessButton>
						</>}
						{recordData?.pay_type_id === PAYROLL_TYPE_OFFCYCLE &&
							<PayrollProcessButton
									payrollId={payrollId}
									process="payreg validated"
									confirmationMessage="Confirming that all records have been validated and are correct."
								>
									PayReg Validated
							</PayrollProcessButton>
						}
			 		</>)}			 					 		
			 		{recordData?.pay_status_id == PAY_STAT_VALIDATED && (<>			 			
			 			{(recordData?.pay_lastest_validation === 'DTR VALIDATED' || recordData?.pay_lastest_validation === 'MANUALLY SET') &&
			 				<PayrollProcessButton
				 				payrollId={payrollId}
	                        	process="payreg validated"
	                        	confirmationMessage="Confirming that all records have been validated and are correct."
				 			>
                            	PayReg Validated
                        	</PayrollProcessButton> 
			 			}
			 			{(recordData?.pay_lastest_validation === 'PAYREG VALIDATED')  &&
			 				<PayrollProcessButton
				 				payrollId={payrollId}
	                        	process="payreg supervisor validated"
	                        	confirmationMessage="Confirming that all records have been validated and are correct."
				 			>
	                            PayReg Supervisor Validated
	                        </PayrollProcessButton>
			 			}
			 			{(recordData?.pay_lastest_validation === 'PAYREG SUPERVISOR VALIDATED') &&
			 				<PayrollProcessButton
				 				payrollId={payrollId}
	                        	process="payreg approved"
	                        	confirmationMessage="Confirming that all records have been reviewed and approved."
				 			>
	                            PayReg Approved
	                        </PayrollProcessButton>
			 			}	
			 		</>)}		      		
		      		{recordData?.pay_status_id === PAY_STAT_APPROVED && 
		      			<PayrollProcessButton className="btn-danger"
		      				payrollId={payrollId}
                        	process="payroll released"
                        	confirmationMessage="Confirming that this payroll is ready for release."
		      			>
                            Release Payroll
                        </PayrollProcessButton>						  
				  	}
					{recordData?.pay_status_id === PAY_STAT_RELEASED && 
		      			<PayrollProcessButton className="btn-danger"
		      				payrollId={payrollId}
                        	process="payslip sent"
                        	confirmationMessage="Confirming that this payroll payslips are ready for release."
		      			>
                            Send Payslips
                        </PayrollProcessButton>						  
				  	}

					{recordData?.pay_type_id == PAYROLL_TYPE_REG && 
				  		<DownloadButton downloadPath="payroll-payrun" title="Payroll DTR" filters={searchFilters}/>
					}
				  	{(recordData?.pay_status_id >= PAY_STAT_DRAFT || recordData?.pay_type_id == PAYROLL_TYPE_OFFCYCLE) && 
			 			<DownloadButton downloadPath="payroll-registry" title="Payroll Registry" filters={searchFilters}/>
			 		}
			 		{recordData?.pay_status_id >= PAY_STAT_APPROVED && 
			 			<DownloadButton downloadPath="payroll-bank-file" title="Bank File" filters={searchFilters}/>
			 		}				  	
				  	{recordData?.pay_status_id === PAY_STAT_RELEASED && 
						<DownloadButton downloadPath="payroll-government-remittance" title="Government Remittance" filters={searchFilters}/>
				  	}	
					
		      	</div>
		      	)}
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  searchFilters: state.payrun.payrunList?.filters,
  recordData: state.payroll.payrollDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewPayroll);
